<div class="label">
  {{ 'findContent.enterPin' | translate }}
</div>
<div [@invalidPinAnimation]="invalidPinMessage" class="input-container">
  @if (auth.isLoggedIn()) {
  <div class="pin-char-prefix">
    {{ editionPrefix }}
  </div>
  } @if (!auth.isLoggedIn()) {
  <input
    (keypress)="keyPress($event)"
    (keyup)="keyUp(0, $event)"
    class="input-0"
    id="input-0"
    class="prefix-box"
    #input
    autofocus
    maxlength="1"
    type="text"
  />
  }
  <span class="pin-char-hyphen"> - </span>
  @for (index of [0, 1, 2, 3, 4, 5]; track index) {
  <input
    (keypress)="keyPress($event)"
    (keyup)="keyUp(auth.isLoggedIn() ? index : index + 1, $event)"
    [class]="'input-' + index"
    [id]="'input-' + index"
    #input
    autofocus
    maxlength="1"
    type="text"
  />
  }
</div>
@if (invalidPinMessage) {
<div class="invalid-message">
  {{ invalidPinMessage | translate }}
</div>
}
